export default "__VITE_ASSET__FboObG47__"